import { useMemo } from "react";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Dialog } from "@remo-co/ui-core/src/components/Dialog";
import { DialogActions } from "@remo-co/ui-core/src/components/DialogActions";
import { DialogContent } from "@remo-co/ui-core/src/components/DialogContent";
import { push } from "connected-react-router";
import { useI18n } from "i18n";
import { useSelector } from "react-redux";
import { useAppDispatch } from "store/hooks";
import { selectEventCompany, selectIsEventManager } from "../selectors";

const TrialExpired = (): JSX.Element | null => {
  const dispatch = useAppDispatch();
  const eventCompany = useSelector(selectEventCompany);
  const isEventManager = useSelector(selectIsEventManager);
  const { t } = useI18n(["common", "company", "event"]);

  const handleTrialPopupClose = () => {
    dispatch(push("/home"));
  };

  const message = useMemo(() => {
    if (!eventCompany) {
      return "";
    }

    const companyName =
      typeof eventCompany === "string" ? eventCompany : eventCompany?.name;

    if (isEventManager) {
      return t("company:trial.expired.message");
    }

    return t("event:plan.expired", {
      key: companyName,
    });
  }, [t, eventCompany, isEventManager]);

  if (!message) {
    return null;
  }

  return (
    <Dialog open onClose={handleTrialPopupClose}>
      <DialogContent>{message}</DialogContent>
      <DialogActions>
        <Button variant="primary" color="blue" onClick={handleTrialPopupClose}>
          {t("button.ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrialExpired;
